import {
  sortTime,
  fixLineData,
  sortArr,
  sortArrDown,
  sortStr,
  sortStr2,
  computeMobileTopPrecent,
  formatNumToNumber,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import {
  getMarketProfileMobileData,
  getPageData,
} from '@/pages/intelligence/services/marketProfile';
import { getCountryFlag } from '@/pages/home/_config/countries';
import {
  pcConsoleFixData,
  getPCConsoleMarkets,
} from '@/pages/intelligence/pages/MarketProfile/_config/_testData';
import globalFlag from '@/pages/intelligence/assets/svg/marketprofile/global.svg';
import globalWoChinaFlag from '@/pages/intelligence/assets/svg/marketprofile/global_wo_china.svg';
import {
  mapColor,
  segmentOptionsMobile,
  lineColor,
  getSortType,
} from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import moment from 'moment';
import { formatNum } from '@/pages/intelligence/utils/commonUtils';
import useMobileGameBarChart from '@/pages/intelligence/pages/MarketProfile/hooks/useMobileGameBarChart';

export default function useDataSearchHook(props: any): any {
  const {
    pageId,
    setTableState,
    setTableLoading,
    setDataState,
    setLineTrendData,
    setSelectedKeys,
    setSelectAllKeys,
    setSelectedKeysColor,
    setGlobelData,
    setAndroidData,
    setIosData,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    setMapData1,
    setMapData2,
    setMapData3,
    setMapData4,
    setShowTableData,
    showTableData,
    setAllTableData,
    allTableData,
    setMarketTableData,
    marketTableData,
    setSelectedMarket,
    selectedMarket,
    allMarkets,
    searchKeyWord,
    setTime,
    time,
    mainSegment,
    setAnnualYearSummary,
    filterData,
    yearData,
    setYearData,
    selectDate,
    changeSelectDate,
  } = props || {};

  const { dealAnnualReportChartsData } = useMobileGameBarChart();

  const computeAnnualReportSummary = (data: any, year: any) => {
    const annualItem = data[year];
    let item = {
      yearTotal: 0,
      yearTotalPrecent: 0,
    };
    if (annualItem) {
      // 选中时间当年的总额
      const total =
        Number(annualItem.mobile_rev) + Number(annualItem.pc_rev) + Number(annualItem.console_rev);

      // 选中时间上年的总额
      const annualItem_prev = data[year - 1];
      // 选中时间当年的增率
      let totalPrecent = 0;
      if (annualItem_prev) {
        const total_prev =
          Number(annualItem_prev.mobile_rev) +
          Number(annualItem_prev.pc_rev) +
          Number(annualItem_prev.console_rev);
        if (total_prev != 0 && total != 0) {
          totalPrecent = (total - total_prev) / total_prev;
        } else if (total_prev == 0 && total != 0) {
          totalPrecent = 1;
        } else {
          totalPrecent = 0;
        }
      }
      item = {
        yearTotal: total,
        yearTotalPrecent: totalPrecent,
      };
    }
    setAnnualYearSummary(item);
  };

  // 数据查询 获取数据
  const dataSearch = async (params: any, init: boolean) => {
    setTableState(0);
    setTableLoading(true);
    setDataState(0);
    let tableData = [] as any;
    // 地图数据渲染
    const data1 = [] as any;
    const data2 = [] as any;
    const data3 = [] as any;
    const data4 = [] as any;

    // pc/console rev数据
    const totalPlayerData = {} as any;
    const totalRevData = {} as any;

    const selectedKeysTemp = [] as any;
    const selectedKeysColorTemp = {} as any;
    const lineTrendDataTemp = {} as any;
    let lineAxis = [] as any;
    let digtalLineAxis = [] as any;
    let totalLineAxis = [] as any;

    const paramData = params;
    if (pageId === 'MarketProfilMobile') {
      // paramData = { ...paramData, genre: [], sub_genre: [] };
      // paramData = {
      //   start_date: paramData.start_date,
      //   end_date: paramData.end_date,
      //   granularity: 'monthly',
      //   source_metrics: {
      //     appannie: ['revenue', 'download', 'game_count'],
      //     sensortower: ['revenue', 'download', 'game_count'],
      //   },
      //   region_type: 'market',
      //   regions: [],
      //   metrics: ['revenue', 'download', 'game_count'],
      //   genres: [],
      //   Platforms: [],
      //   b_group_by_region: false,
      //   b_group_by_date: false,
      //   b_growth_ratio: true,
      //   b_group_by_platform: true,
      //   b_group_by_genre: false,
      // };
    }

    // console.log('getPageData-pageId', pageId);
    // console.log('getPageData-paramData', paramData);
    let res: any = {};
    if (pageId === 'MarketProfilMobile') {
      res = await getMarketProfileMobileData(paramData);
    } else {
      res = await getPageData(
        pageId === 'MarketProfilPC' || pageId === 'MarketProfilConsole'
          ? 'pc_console_table'
          : 'annual_report',
        paramData,
      );
    }

    // console.log('getPageData-res', res);

    if (pageId == 'MarketProfilMobile') {
      const global = res?.global_performance;
      const android = res?.android;
      const ios = res?.ios;
      if (res?.start_date && res?.end_date && init) {
        const timeTemp = [res?.start_date, res?.end_date];
        !selectDate[0] && changeSelectDate(timeTemp);
        setTime(timeTemp);
      }
      if (res?.date_list) {
        lineAxis = res?.date_list.sort();
      }
      if (res?.market_list) {
        const marketList = res?.market_list;
        const globalData = [] as any;
        const otherData = [] as any;
        marketList.sort(sortArr('rev'));
        let rankNum = 0;
        marketList.map((item: any) => {
          // 收入数据
          const obj1 = {
            name: item.country_name_en == 'Congo' ? 'Republic of the Congo' : item.country_name_en,
            value: item.rev,
            gameCount: item.game_count,
          };
          data1.push(obj1);
          // 下载数据
          const obj2 = {
            name: item.country_name_en == 'Congo' ? 'Republic of the Congo' : item.country_name_en,
            value: item.downLoad,
            gameCount: item.game_count,
          };
          data2.push(obj2);

          const revenue = item?.rev || 0;
          const revenue_pre = item?.pre_rev || 0;
          const download = item?.downLoad || 0;
          const download_pre = item?.pre_download || 0;
          let revenue_precent = 0;
          let download_precent = 0;

          if (revenue == 0) {
            revenue_precent = 0;
          } else {
            if (revenue_pre == 0) {
              revenue_precent = 1;
            } else {
              revenue_precent = (revenue - revenue_pre) / revenue_pre;
            }
          }

          if (download == 0) {
            download_precent = 0;
          } else {
            if (download_pre == 0) {
              download_precent = 1;
            } else {
              download_precent = (download - download_pre) / download_pre;
            }
          }
          let tempRank;
          let itemFlag;
          if (item.market == 'global') {
            tempRank = '-';
            itemFlag = globalFlag;
          } else if (item.market == 'global_wo_china') {
            tempRank = '- ';
            itemFlag = globalWoChinaFlag;
          } else {
            rankNum += 1;
            tempRank = rankNum;
            itemFlag = item.flag;
          }

          const tableObj = {
            rank: tempRank,
            marketNameEn: item.market,
            marketName:
              item.country_name_en == 'Congo' ? 'Republic of the Congo' : item.country_name_en,
            marketFlag: itemFlag,
            marketRevenue: revenue,
            marketRevenuePrecent: revenue_precent,
            marketDownloads: download,
            marketDownloadsPrecent: download_precent,
            is_annie: item.is_annie,
          };
          if (item.market == 'global' || item.market == 'global_wo_china') {
            globalData.push(tableObj);
          } else {
            otherData.push(tableObj);
          }

          if (
            selectedKeysTemp.length < 6 &&
            item.market != 'global' &&
            item.market != 'global_wo_china'
          ) {
            selectedKeysColorTemp[item.country_name_en] = lineColor[selectedKeysTemp.length];
            selectedKeysTemp.push(item.country_name_en);
          }

          let revenueLine = [] as any;
          let downloadLine = [] as any;
          if (item.line) {
            item.line.sort(sortTime('date')).map((obj: any) => {
              const { date } = obj;
              if (lineAxis.indexOf(date) != -1) {
                revenueLine = fixLineData(revenueLine, lineAxis.indexOf(date));
                revenueLine.push(obj.revenue == 0 ? '-' : obj.revenue);
                downloadLine = fixLineData(downloadLine, lineAxis.indexOf(date));
                downloadLine.push(obj.downloads == 0 ? '-' : obj.downloads);
              }
            });
          }
          lineTrendDataTemp[item.country_name_en] = {
            revenue: revenueLine,
            download: downloadLine,
          };

          // let countryData = {
          //   name:
          //     item.country_name_en == 'Congo'
          //       ? 'Republic of the Congo'
          //       : item.country_name_en,
          //   enName: item.market,
          //   flag: itemFlag,
          // };
          // countryMapData.push(countryData);
        });

        tableData = globalData.concat(otherData);
      }

      const axix = [] as any;
      lineAxis.map((item: any) => {
        axix.push(moment(item).format('YYYY-MM'));
      });

      lineTrendDataTemp.xAxis = axix;
      setLineTrendData(lineTrendDataTemp);

      // worldMapExample(
      //   mainSegment == 'Revenue' ? data1 : data2,
      //   'mpGameMap' + pageId,
      //   mapColor,
      // );

      setSelectedKeys(selectedKeysTemp);
      setSelectAllKeys(selectedKeysTemp);
      setSelectedKeysColor(selectedKeysColorTemp);

      setGlobelData(computeMobileTopPrecent(global));
      setAndroidData(computeMobileTopPrecent(android));
      setIosData(computeMobileTopPrecent(ios));

      mapData1.length = 0;
      mapData1.push(...data1);
      setMapData1(mapData1);

      mapData2.length = 0;
      mapData2.push(...data2);
      setMapData2(mapData2);
    } else if (pageId == 'MarketProfilPC' || pageId == 'MarketProfilConsole') {
      const tempData = {};
      let lineSearchTime = [] as any; // 用于初次请求line的时间
      if (res?.start_date && res?.end_date && init) {
        const timeTemp = [res?.start_date, res?.end_date];
        !selectDate[0] && changeSelectDate(timeTemp);
        setTime(timeTemp);

        const startYear = Number(res?.start_date.slice(0, 4));
        const endYear = Number(res?.end_date.slice(0, 4));
        const endTime = !selectDate[1]
          ? moment(res?.end_date).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD')
          : '';

        lineSearchTime = !selectDate[0]
          ? [res?.start_date, endTime]
          : [res?.start_date, paramData.end_date];

        let showYear = '';
        if (startYear === endYear) {
          showYear = `in ${startYear}`;
          setYearData(`in ${startYear}`);
        } else {
          showYear = `Sum of ${startYear}-${endYear}`;
          setYearData(`Sum of ${startYear}-${endYear}`);
        }
      }
      const lineData = (await getPageData(
        'pc_console_trend',
        init
          ? { ...paramData, start_date: lineSearchTime[0], end_date: lineSearchTime[1] }
          : paramData,
      )) as any;
      if (res?.list) {
        const marketList = res?.list;
        marketList.sort(sortArr('digtal_rev'));
        marketList.map((item: any) => {
          // 收入数据
          const obj1 = {
            name: item.country_name_en,
            value: Math.floor(item.digtal_rev * 100) / 100,
            gameCount: item.digtal_game_count,
          };
          data1.push(obj1);
          // 下载数据
          const obj2 = {
            name: item.country_name_en,
            value: Math.floor(item.physical_rev * 100) / 100,
            gameCount: item.physical_game_count,
          };
          data2.push(obj2);
          // total_rev 暂存对应游戏数据
          totalRevData[item.country_name_en] = formatNum(Math.floor(item.total_rev * 100) / 100);
          // total_player 暂存对应游戏数据
          totalPlayerData[item.country_name_en] = formatNum(
            Math.floor(item.total_player * 100) / 100,
          );

          const digtal_rev = item?.digtal_rev || 0;
          const pre_digtal_rev = item?.pre_digtal_rev || 0;
          const physical_rev = item?.physical_rev || 0;
          const pre_physical_rev = item?.pre_physical_rev || 0;
          const total_rev = item?.total_rev || 0;
          const total_player = item?.total_player || 0;
          let digtal_precent = 0;
          let physical_precent = 0;

          if (digtal_rev == 0) {
            digtal_precent = 0;
          } else {
            if (pre_digtal_rev == 0) {
              digtal_precent = 1;
            } else {
              digtal_precent = (digtal_rev - pre_digtal_rev) / pre_digtal_rev;
            }
          }
          console.log(item, digtal_rev, "9999999999999999999991111111111jjjjjjj");
          if (physical_rev == 0) {
            physical_precent = 0;
          } else {
            if (pre_physical_rev == 0) {
              physical_precent = 1;
            } else {
              physical_precent = (physical_rev - pre_physical_rev) / pre_physical_rev;
            }
          }

          const countryName = item.country_name_en;
          // let totalRevenue = '-';
          // let totalPlayer = '-';
          // if (pcConsoleFixData[countryName]) {
          //   if (pageId == 'MarketProfilPC') {
          //     totalRevenue = pcConsoleFixData[countryName]['pcRevenue'] || '-';
          //     totalPlayer = pcConsoleFixData[countryName]['pcPlayer'] || '-';
          //   } else {
          //     totalRevenue =
          //       pcConsoleFixData[countryName]['consoleRevenue'] || '-';
          //     totalPlayer =
          //       pcConsoleFixData[countryName]['consolePlayer'] || '-';
          //   }
          // }

          // table数据和line数据接口拆分，这里重新整合
          const totalRevTag = pageId === 'MarketProfilPC' ? 'pcRevenue' : 'consoleRevenue';
          const totalPlayerTag = pageId === 'MarketProfilPC' ? 'pcPlayer' : 'consolePlayer';
          const tableObj = {
            marketName: item.country_name_en,
            marketNameEn: item.market,
            marketFlag: getCountryFlag(item.market),
            marketDigitalRevenue: Math.floor(digtal_rev * 100) / 100,
            marketDigitalRevenuePrecent: item.digtal_rev_dod,
            marketPhysicalRevenue: Math.floor(physical_rev * 100) / 100,
            marketPhysicalRevenuePrecent: item.physical_rev_dod,
            [totalRevTag]: formatNum(Math.floor(total_rev * 100) / 100),
            [totalPlayerTag]: formatNum(Math.floor(total_player * 100) / 100),
            lineData: item.line,
          };
          tempData[countryName] = tableObj;
        });
      }
      // 处理newzoo data数据
      const _param = {
        entity_type: pageId == 'MarketProfilPC' ? 'pc' : 'console',
        start_date: '',
        end_date: '',
        data_source: 'newzoo',
      };
      const newzooRes = await getPageData('game_count', _param);
      if (newzooRes) {
        const newzooData = newzooRes;
        newzooData.map((item: any) => {
          const countryNameTemp = item.country_name_en;
          const obj1 = {
            name: countryNameTemp,
            value: formatNumToNumber(totalRevData[countryNameTemp] || '-'),
            gameCount: Math.floor(item.count * 100) / 100,
            showNum: formatNumToNumber(totalRevData[countryNameTemp] || '-'),
          };
          data3.push(obj1);
          const obj2 = {
            name: countryNameTemp,
            value: formatNumToNumber(totalPlayerData[countryNameTemp] || '-'),
            gameCount: Math.floor(item.count * 100) / 100,
            showNum: formatNumToNumber(totalPlayerData[countryNameTemp] || '-'),
          };
          data4.push(obj2);

          // let fixDataItem = pcConsoleFixData[countryNameTemp];
          // if (fixDataItem) {
          //   let totalRevenue =
          //     fixDataItem[
          //       pageId == 'MarketProfilPC' ? 'pcRevenue' : 'consoleRevenue'
          //     ];
          //   let obj1 = {
          //     name: countryNameTemp,
          //     value: formatNumToNumber(totalRevenue),
          //     gameCount: Math.floor(item.count * 100) / 100,
          //     showNum: totalRevenue,
          //   };
          //   data3.push(obj1);
          //   let totalPlayer =
          //     fixDataItem[
          //       pageId == 'MarketProfilPC' ? 'pcPlayer' : 'consolePlayer'
          //     ];
          //   let obj2 = {
          //     name: countryNameTemp,
          //     value: formatNumToNumber(totalPlayer),
          //     gameCount: Math.floor(item.count * 100) / 100,
          //     showNum: totalPlayer,
          //   };
          //   data4.push(obj2);
          // }
        });
      }
      // x轴日期数组
      digtalLineAxis = lineData?.digtal_rev?.[0].history.map((item: any) => item.date).sort() || [];
      totalLineAxis = lineData?.total_rev?.[0].history.map((item: any) => item.date).sort() || [];

      Object.keys(tempData).map((key: any) => {
        // let item = tempData[key];
        const obj = tempData[key] as any;

        let digitalRevenue = [] as any;
        let physicalRevenue = [] as any;
        let totalRevenue = [] as any;
        let totalPlayer = [] as any;
        // if (obj) {
        // item['marketName'] = obj['marketName'];
        // item['marketFlag'] = obj['marketFlag'];
        // item['marketDigitalRevenue'] = obj['marketDigitalRevenue'];
        // item['marketDigitalRevenuePrecent'] =
        //   obj['marketDigitalRevenuePrecent'];
        // item['marketPhysicalRevenue'] = obj['marketPhysicalRevenue'];
        // item['marketPhysicalRevenuePrecent'] =
        //   obj['marketPhysicalRevenuePrecent'];
        // item['pcRevenue'] = obj['pcRevenue'];
        // item['consoleRevenue'] = obj['consoleRevenue'];
        // item['pcPlayer'] = obj['pcPlayer'];
        // item['consolePlayer'] = obj['consolePlayer'];
        // 含有physical revenue数据的国家，目前只有us有，其他国家不用处理physical revenue数据。
        // 如果需要添加处理国家数据，在physical中加入国家简写即可
        // let physical = ['us'];
        // if (obj['lineData']) {
        // console.log('obj_lineData',obj['lineData'],lineData.digtal_rev,key);
        // 匹配到对应国家此字段的图表数据
        const digtalLineData =
          lineData?.digtal_rev
            ?.find((item) => item.country_name_en === key)
            ?.history.sort(sortArrDown('date')) || [];
        digtalLineData.map((lItem: any) => {
          const { date } = lItem;
          if (digtalLineAxis.indexOf(date) != -1) {
            digitalRevenue = fixLineData(digitalRevenue, digtalLineAxis.indexOf(date));
            digitalRevenue.push(lItem.value == 0 ? '-' : lItem.value?.toFixed(2));
          }
        });
        const physicalLineData =
          lineData?.physical_rev
            ?.find((item) => item.country_name_en === key)
            ?.history.sort(sortArrDown('date')) || [];
        physicalLineData.map((lItem: any) => {
          const { date } = lItem;
          if (digtalLineAxis.indexOf(date) != -1) {
            physicalRevenue = fixLineData(physicalRevenue, digtalLineAxis.indexOf(date));
            physicalRevenue.push(lItem.value == 0 ? '-' : lItem.value?.toFixed(2));
          }
        });
        const totalRevLineData =
          lineData?.total_rev
            ?.find((item) => item.country_name_en === key)
            ?.history.sort(sortArrDown('date')) || [];
        totalRevLineData.map((lItem: any) => {
          const { date } = lItem;
          if (totalLineAxis.indexOf(date) != -1) {
            totalRevenue = fixLineData(totalRevenue, totalLineAxis.indexOf(date));
            totalRevenue.push(lItem.value == 0 ? '-' : lItem.value?.toFixed(2));
          }
        });
        const totalPlayLineData =
          lineData?.total_player
            ?.find((item) => item.country_name_en === key)
            ?.history.sort(sortArrDown('date')) || [];
        totalPlayLineData.map((lItem: any) => {
          const { date } = lItem;
          if (totalLineAxis.indexOf(date) != -1) {
            totalPlayer = fixLineData(totalPlayer, totalLineAxis.indexOf(date));
            totalPlayer.push(lItem.value == 0 ? '-' : lItem.value?.toFixed(2));
          }
        });

        // obj['lineData'].sort(sortTime('date')).map((lItem:any) => {
        //   console.log('old-lItem',lItem);

        //   let date = lItem['date'];
        //   if (lineAxis.indexOf(date) != -1) {
        //     digitalRevenue = fixLineData(
        //       digitalRevenue,
        //       lineAxis.indexOf(date),
        //     );
        //     console.log('fix-digitalRevenue',digitalRevenue);

        //     digitalRevenue.push(
        //       lItem['digtal_rev'] == 0
        //         ? '-'
        //         : lItem['digtal_rev']?.toFixed(2),
        //     );
        //     if (physical.indexOf(item['marketNameEn']) != -1) {
        //       physicalRevenue = fixLineData(
        //         physicalRevenue,
        //         lineAxis.indexOf(date),
        //       );
        //       physicalRevenue.push(
        //         lItem['physical_rev'] == 0
        //           ? '-'
        //           : lItem['physical_rev']?.toFixed(2),
        //       );
        //     }
        //   }
        // });
        // }
        // } else {
        //   item['marketDigitalRevenue'] = 0;
        //   item['marketDigitalRevenuePrecent'] = 0;
        //   item['marketPhysicalRevenue'] = 0;
        //   item['marketPhysicalRevenuePrecent'] = 0;
        //   item['pcRevenue'] = 0;
        //   item['consoleRevenue'] = 0;
        //   item['pcPlayer'] = 0;
        //   item['consolePlayer'] = 0;
        // }
        lineTrendDataTemp[obj.marketName] = {
          digitalRevenue,
          physicalRevenue,
          totalRevenue,
          totalPlayer,
        };
        tableData.push(obj);

        // let countryData = {
        //   name: item.marketName,
        //   enName: item.marketNameEn,
        //   flag: item.marketFlag,
        // };
        // countryMapData.push(countryData);
      });
      tableData.sort(sortArr('marketDigitalRevenue'));
      tableData.map((item: any, index: number) => {
        item.rank = index + 1;
        if (selectedKeysTemp.length < 6) {
          selectedKeysColorTemp[item.marketName] = lineColor[selectedKeysTemp.length];
          selectedKeysTemp.push(item.marketName);
        }
      });

      const axix = [] as any;
      digtalLineAxis?.map((item: any) => {
        axix.push(moment(item).format('YYYY-MM'));
      });

      lineTrendDataTemp.xAxis = axix;
      // if(time[0].slice(0,4) === time[1].slice(0,4))
      lineTrendDataTemp.totalAxis = totalLineAxis;
      setLineTrendData(lineTrendDataTemp);
      // let value = localStorage.getItem('mpMapSerieName');
      // worldMapExample(
      //   value == 'Digital'
      //     ? data1
      //     : value == 'Physical'
      //     ? data2
      //     : value == 'TotalRevenue'
      //     ? data3
      //     : data4,
      //   'mpGameMap' + pageId,
      //   mapColor,
      // );

      setSelectedKeys(selectedKeysTemp);
      setSelectAllKeys(selectedKeysTemp);
      setSelectedKeysColor(selectedKeysColorTemp);

      mapData1.length = 0;
      mapData1.push(...data1);
      setMapData1(mapData1);

      mapData2.length = 0;
      mapData2.push(...data2);
      setMapData2(mapData2);

      mapData3.length = 0;
      mapData3.push(...data3);
      setMapData3(mapData3);

      mapData4.length = 0;
      mapData4.push(...data4);
      setMapData4(mapData4);
    } else if (pageId == 'MarketProfilAnnualReport') {
      if (res) {
        const annualSummary = {} as any;
        const summary = res?.global_game_market_summary;
        if (summary?.length > 0) {
          summary.map((item: any) => {
            annualSummary[item.year] = item;
          });
        }
        if (res?.market_list) {
          const marketList = res?.market_list;
          let rankNum = 0;
          marketList.sort(sortArr('rev')); // 根据rev排序
          marketList.map((item: any) => {
            if (item.market !== 'global' && item.market !== 'global_wo_china') {
              // 地图数据
              const obj1 = {
                name: item.country_name_en,
                value: item.rev,
                gameCount: item.game_count,
              };
              data1.push(obj1);

              const revenue = item?.rev || 0;
              const revenue_pre = item?.pre_rev || 0;
              const game_count = item?.game_count || 0;
              const pre_game_count = item?.pre_game_count || 0;
              let revenue_precent = 0;
              let game_count_precent = 0;

              if (revenue === 0) {
                revenue_precent = 0;
              } else {
                if (revenue_pre === 0) {
                  revenue_precent = 1;
                } else {
                  revenue_precent = (revenue - revenue_pre) / revenue_pre;
                }
              }

              if (game_count == 0) {
                game_count_precent = 0;
              } else {
                if (pre_game_count == 0) {
                  game_count_precent = 1;
                } else {
                  game_count_precent = (game_count - pre_game_count) / pre_game_count;
                }
              }
              rankNum += 1;
              const tableObj = {
                rank: rankNum,
                marketNameEn: item.market,
                marketName: item.country_name_en,
                marketFlag: item.flag,
                marketRevenue: revenue,
                marketRevenuePrecent: revenue_precent,
                gameCount: game_count,
                gameCountPrecent: game_count_precent,
              };
              tableData.push(tableObj);

              mapData1.length = 0;
              mapData1.push(...data1);
              setMapData1(mapData1);

              // let countryData = {
              //   name: item.country_name_en,
              //   enName: item.market,
              //   flag: item.flag,
              // };
              // countryMapData.push(countryData);
            }
          });
        }

        // worldMapExample(data1, 'mpGameMap' + pageId, mapColor);
        computeAnnualReportSummary(annualSummary, paramData.year);
        dealAnnualReportChartsData(annualSummary, paramData.year);
      }
    }

    showTableData.length = 0;
    showTableData.push(...tableData);
    setShowTableData(showTableData);

    allTableData.length = 0;
    allTableData.push(...tableData);
    setAllTableData(allTableData);

    marketTableData.length = 0;
    marketTableData.push(...tableData);
    setMarketTableData(marketTableData);

    /** 重置国家筛选器值为All */
    if (allMarkets.length && !selectedMarket?.length) {
      setSelectedMarket(allMarkets);
    }

    // todo 需要根据结果中的market_list去更改状态1 2
    if (tableData.length > 0) {
      setTableState(1);
      filterData(searchKeyWord?.length > 0 ? searchKeyWord[0] : '');
    } else {
      setTableState(2);
    }
    setDataState(1);
    setTableLoading(false);
  };

  return { dataSearch };
}
